export default {
  branches(state, branches) {
    return (state.branches = branches);
  },

  branchTotal(state, total) {
    return (state.branchTotal = total);
  },

  currentViewedBranch(state, branch) {
    return (state.currentViewedBranch = branch);
  },

  tableLoader(state, value) {
    return (state.tableLoading = value);
  },

  currentPage(state, value) {
    return (state.currentPage = value);
  },

  perPage(state, value) {
    return (state.perPage = value);
  },

  searchQuery(state, value) {
    return (state.searchQuery = value);
  },

  filterValue(state, value) {
    return (state.filterValue = value);
  },

  branchTypes(state, value) {
    return (state.branchTypes = value);
  },
};
